import { TargetIcon, UsersIcon, MoonIcon, LogOutIcon, SunIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import type { HouseMode } from '../types/anna';

export const houseModes: {
  id: HouseMode;
  icon: LucideIcon;
  description: string;
  glow: string;
}[] = [
  { id: 'Focus', icon: TargetIcon, description: 'Werkblok. Anna dimt en meldt alleen wat dringend is.', glow: 'Neutraal' },
  { id: 'Samen', icon: UsersIcon, description: 'Je bent met anderen. Anna is terughoudend en toont niets persoonlijks.', glow: 'Warm, zacht' },
  { id: 'Slapen', icon: MoonIcon, description: 'Alles gedempt. Alleen veiligheidsalarmen komen door.', glow: 'Bijna zwart' },
  { id: 'Afwezig', icon: LogOutIcon, description: 'Niemand thuis. Bewaken en besparen; meldingen naar je telefoon.', glow: 'Gedimd, koel' },
  { id: 'Vrij', icon: SunIcon, description: 'Standaard. Anna is proactief binnen de vaste grenzen.', glow: 'Volgt de tijd van de dag' },
];
